import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { switchMap } from 'rxjs/operators';

import { CartServiceV2 } from '../services/cart-v2.service';
import {
  LOAD_USER_SUCCESS,
  LOG_USER_OUT,
} from '../../users/store/user.actions';

import {
  LOAD_CART,
  LoadCart,
  LoadCartFail,
  LoadCartSuccess,
} from './cart.actions';

@Injectable()
export class CartEffects {
  private readonly _actions$ = inject(Actions);
  private readonly _cartServiceV2 = inject(CartServiceV2);

  loadCart$ = createEffect(() =>
    this._actions$.pipe(
      ofType(LOAD_CART),
      switchMap((action: LoadCart) => {
        return this.fetchCartAction(action.payload);
      }),
    ),
  );

  loadCartAfterLoginSuccess$ = createEffect(() =>
    this._actions$.pipe(
      ofType(LOAD_USER_SUCCESS),
      switchMap((action) => {
        const {
          payload: {
            hasCustomerId,
            customDeliveryPriceEnabled,
            deliveryPrice,
            invoiceInfo,
          },
        } = action as any;
        let options: {
          priceReducePercent: number;
          deliveryPrice?: number;
          customDeliveryPriceEnabled?: boolean;
        } = {
          priceReducePercent: hasCustomerId ? invoiceInfo.company.discount : 0,
        };

        if (hasCustomerId && customDeliveryPriceEnabled) {
          options = { ...options, deliveryPrice, customDeliveryPriceEnabled };
        }

        return this.fetchCartAction(options);
      }),
    ),
  );

  loadCartAfterLogout$ = createEffect(() =>
    this._actions$.pipe(
      ofType(LOG_USER_OUT),
      switchMap(() => {
        this._cartServiceV2.cleanKey();
        return this.fetchCartAction();
      }),
    ),
  );

  private fetchCartAction(options?: {
    priceReducePercent?: number;
    deliveryPrice?: number;
    customDeliveryPriceEnabled?: boolean;
  }): Promise<LoadCartSuccess | LoadCartFail> {
    return this._cartServiceV2
      .fetchCart(true, options)
      .then((cart) => new LoadCartSuccess(cart))
      .catch((err) => new LoadCartFail(err));
  }
}
